export default __webpack_public_path__ + "static/media/Selection_Statistics_Template.a50b821d.xlsx";